export const colors = {
  lightBlue: '#3F85EF',
  blue: '#2B75E6',
  darkBlue: '#123173',
  reallyDarkBlue: '#162253',
  orange: '#E57502',
  lightGreen: '#40E7B9',
  gray: '#8D8D8D',
  lime: '#90AB00',
  limeDeckRGB: [144, 171, 0, 255 * 0.5],
  yellow: '#FFC400',
};

export const mobileBreakpoint = 978;
export const smallMobileBreakpoint = 830;
const mediaQueryCond = `(max-width: ${mobileBreakpoint}px)`;
const smallMediaQueryCond = `(max-width: ${smallMobileBreakpoint}px)`;

export const mobileMQ = `@media ${mediaQueryCond}`;
export const smallMobileMQ = `@media ${smallMediaQueryCond}`;

export const globalStyles = {
  '.js-focus-visible :focus:not(.focus-visible)': {
    outline: 'none',
  },
  '.smu-root *': {
    fontFamily: `Proxima Nova, BlinkMacSystemFont, "Segoe UI", "Roboto", "Oxygen",
    "Ubuntu", "Cantarell", "Fira Sans", "Droid Sans", "Helvetica Neue",
    sans-serif`,
    WebkitFontSmoothing: 'antialiased',
    MozOsxFontSmoothing: 'grayscale',
    margin: 0,
    padding: 0,
    boxSizing: 'border-box',
    '& *::-webkit-scrollbar': {
      backgroundColor: 'rgba(255,255,255,0.2)',
      borderRadius: 6,
      width: 9,
      height: 5,
    },
    '& *::-webkit-scrollbar-thumb': {
      backgroundColor: colors.blue,
      borderRadius: 6,
    },
    '& table': {
      //overriding frogs global styles
      borderCollapse: 'initial',
    },
  },
};
